<template>
  <v-container fluid grid-list-md class="grad">
    <v-row>
      <!-- Profile Badge -->
      <v-col md="3">
        <v-card height="full-height" flat>
          <v-card-title class="justify-center">
            <input
              type="file"
              style="display: none"
              ref="fileInput"
              @change="onFilePicked"
            />
            <v-hover v-slot:default="{ hover }">
              <v-avatar
                class="mx-auto d-block lighten-2"
                color="blue"
                size="130"
              >
                <v-img
                  v-if="user.photoUrl"
                  :src="photoConvert(user.photoUrl)"
                  alt="Sportopia avatar"
                  contain
                  :lazy-src="photoConvert(user.photoUrl)"
                />
                <v-icon v-else dark x-large>mdi-account</v-icon>
                <v-expand-transition mode="out-in">
                  <div
                    @click="onPickFile"
                    v-if="hover"
                    class="d-flex round grey darken-3 v-card--reveal white--text"
                    style="height: 100%"
                  >
                    Upload
                  </div>
                </v-expand-transition>
              </v-avatar>
            </v-hover>
          </v-card-title>
          <v-card-text class="justify-center">
            <!-- general info form -->
            <GeneralInfoForm
              ref="generalInfo"
              v-bind.sync="user"
              :type="user.type"
            />
            <v-btn
              block
              color="success"
              v-if="user.type === 'coach'"
              to="/profile/packs"
              >Modifier vos Packs</v-btn
            >
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn
              color="error darken-2"
              rounded
              text
              class="font-weight-light"
              @click="onLogout"
              >Quitter</v-btn
            >
          </v-card-actions>
        </v-card>
        <!-- CALENDAR -->
        <!-- <v-flex v-if="user.type == 'coach'">
            <v-card height="full-height">
              <GymPlanningCalendar />
            </v-card>
        </v-flex>-->
      </v-col>

      <v-col xs="12" md="9" fill-height>
        <!-- USER -->
        <v-card flat v-if="user.type == 'user'">
          <v-container>
            <div>
              <v-subheader>Information générale</v-subheader>
              <v-divider inset />
            </div>
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre taille</v-subheader>
                <v-slider
                  v-model="user.height"
                  max="218"
                  min="100"
                  thumb-size="24"
                  prepend-icon="$vuetify.measure"
                  thumb-label="always"
                ></v-slider>
              </v-col>
              <v-col cols="12" md="6">
                <v-subheader class="pl-0">Votre poids</v-subheader>
                <v-slider
                  v-model="user.weight"
                  max="300"
                  min="30"
                  thumb-size="24"
                  prepend-icon="$vuetify.scale"
                  thumb-label="always"
                ></v-slider>
              </v-col>
            </v-row>
            <div>
              <v-subheader>Contact</v-subheader>
              <v-divider inset />
            </div>
            <ContactForm ref="contactForm" v-bind.sync="user" />
            <v-row align="center" justify="end">
              <v-btn
                :loading="loading"
                class="mx-0 font-weight-light secondary"
                text
                @click="onUpdateClick"
                >Enregistrer</v-btn
              >
            </v-row>
            <div>
              <v-subheader>Sécurité</v-subheader>
              <v-divider inset />
            </div>
            <PasswordForm ref="passwordForm" />
          </v-container>
        </v-card>

        <!-- PARTNER -->
        <v-card v-else flat>
          <v-tabs v-model="tab" fixed-tabs background-color="indigo" dark>
            <v-tab>Informations générale</v-tab>
            <v-tab>Professionel</v-tab>
            <v-tab v-if="user.type == 'coach'">Expérience</v-tab>
            <v-tab>Diplome</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="pa-2">
            <v-tab-item>
              <v-col cols="12">
                <v-textarea
                  rows="3"
                  no-resize
                  color="secondary"
                  label="A propos"
                  counter
                  v-model="user.description"
                />
              </v-col>
              <ContactForm ref="contactForm" v-bind.sync="user" />
              <div>
                <v-subheader>Réseaux sociaux</v-subheader>
                <v-divider inset />
              </div>
              <SocialForm
                v-if="user.type != 'user'"
                ref="socialForm"
                v-bind.sync="user"
              />
              <div>
                <v-subheader>Sécurité</v-subheader>
                <v-divider inset />
              </div>
              <PasswordForm ref="passwordForm" />
            </v-tab-item>
            <!-- Professional -->
            <v-tab-item>
              <v-row>
                <!-- sessionPrice: ALL -->
                <!-- <v-col cols="12" md="3" sm="3">
                  <v-text-field
                    label="Prix de la séance"
                    color="secondary"
                    prepend-inner-icon="mdi-cash"
                    type="number"
                    suffix="dinars"
                    :error-messages="sessionPriceErrors"
                    @input="$v.user[user.type].sessionPrice.$touch()"
                    @blur="$v.user[user.type].sessionPrice.$touch()"
                    v-model="user[user.type].sessionPrice"
                  />
                </v-col> -->
                <!-- sessionLength: ALL-->
                <v-col cols="12" md="3" sm="3">
                  <v-text-field
                    label="Longuer de la séance"
                    color="secondary"
                    prepend-inner-icon="mdi-clock"
                    type="number"
                    suffix="Min"
                    :error-messages="sessionLengthErrors"
                    @input="$v.user[user.type].sessionLength.$touch()"
                    @blur="$v.user[user.type].sessionLength.$touch()"
                    v-model="user[user.type].sessionLength"
                  />
                </v-col>
                <!-- CNAM: NUTRITION & PHYSIO-->
                <v-col
                  v-if="user.type !== 'coach'"
                  cols="12"
                  md="4"
                  sm="6"
                  class="pb-0 pt-1 px-1"
                >
                  <v-switch
                    color="success"
                    :ripple="false"
                    label="Conventioné avec CNAM?"
                    v-model="user[user.type].cnam"
                  ></v-switch>
                </v-col>
                <!-- online: NUTRITION -->
                <v-col
                  v-if="user.type == 'nutrition'"
                  cols="12"
                  md="3"
                  class="pb-0 pt-1 px-1"
                >
                  <v-switch
                    color="success"
                    :ripple="false"
                    v-model="user[user.type].online"
                    label="tu travail en ligne?"
                  ></v-switch>
                </v-col>
                <!-- location: COACH -->
                <!-- <v-col v-if="user.type == 'coach'" cols="12" md="6" sm="6">
                  <v-combobox
                    multiple
                    :items="[
                      'à l\'extérieur',
                      'Chez vous',
                      'Chez le client',
                      'Salle de sport',
                    ]"
                    v-model="user[user.type].sessionLocation"
                    label="l'emplacement des séances"
                    append-icon
                  ></v-combobox>
                </v-col> -->
                <!-- spcialité: COACH & PHYSIO -->
                <v-col v-if="user.type !== 'nutrition'" cols="12" md="6" sm="6">
                  <v-combobox
                    v-model="user[user.type].specialities"
                    :items="specialityItems"
                    :search-input.sync="search"
                    hide-selected
                    hint="Maximum 5 Spécialités"
                    label="Spécialité"
                    placeholder="Spécialités"
                    multiple
                    persistent-hint
                    chips
                    clearable
                    class="text-capitalize"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            pas de résultat trouvé "<strong>{{ search }}</strong
                            >". Clicker <kbd>enter</kbd> pour créer une nouvelle
                            spécialité
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template></v-combobox
                  >
                </v-col>
                <!-- equipments: COACH & PHYSIO -->
                <v-col v-if="user.type !== 'nutrition'" cols="12" md="6" sm="6">
                  <v-combobox
                    multiple
                    v-model="user[user.type].equipments"
                    label="Equipements"
                    append-icon
                    chips
                    deletable-chips
                    class="tag-input"
                  ></v-combobox>
                </v-col>
                <!-- disponibility: COACH -->
                <v-col v-if="user.type == 'coach'" cols="12" md="6" sm="6">
                  <Disponibility />
                </v-col>
                <!-- train at home: COACH -->
                <!-- <v-col v-if="user.type == 'coach'" cols="12" md="6" sm="6">
                  <v-switch
                    flat="flat"
                    prepend-icon="mdi-home"
                    :inset="false"
                    color="secondary"
                    :ripple="false"
                    label="Des sessions à domicile?"
                    v-model="user[user.type].atHome"
                  ></v-switch>
                </v-col> -->
                <!-- openningHours -->
                <AddOpenningHours
                  v-if="user.type !== 'coach'"
                  :openningHours.sync="user[user.type].openningHours"
                />
              </v-row>
            </v-tab-item>
            <v-tab-item v-if="user.type == 'coach'">
              <!-- Expérience -->
              <v-row no-gutters class v-if="user.type == 'coach'">
                <ExperienceComponent
                  :experiences="user.coach.experience"
                ></ExperienceComponent>
                <v-col cols="12" md="12">
                  <ExperienceDialog />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <!-- Diplome -->
              <div v-if="user.type !== 'user' && user.type !== 'gym'">
                <DiplomaComponent
                  v-for="(item, i) in user[user.type].diploma"
                  :key="i"
                  :diploma="item"
                ></DiplomaComponent>
                <v-col cols="12">
                  <DiplomaDialog />
                </v-col>
              </div>
            </v-tab-item>
          </v-tabs-items>

          <v-divider />

          <v-card-actions class="justify-end">
            <v-container>
              <v-row align="center" justify="end">
                <v-btn
                  :loading="loading"
                  class="mx-0 font-weight-light secondary"
                  text
                  @click="onUpdateClick"
                  >Enregistrer</v-btn
                >
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ExperienceDialog from "@/components/ExperienceDialog";
import {
  ExperienceComponent,
  DiplomaComponent,
} from "@/components/partnerComponents";
import SnackNotification from "@/components/SnackNotification.vue";
import {
  GeneralInfoForm,
  ContactForm,
  SocialForm,
  PasswordForm,
  DiplomaDialog,
} from "@/components/profile";

import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";

import Disponibility from "@/components/coachComponents/Disponibilty.vue";
import AddOpenningHours from "@/components/profile/AddOpenningHours";

export default {
  mixins: [validationMixin],
  validations() {
    return {
      user: {
        [this.user.type]: {
          sessionPrice: { required, minValue: minValue(10) },
          sessionLength: { required, minValue: minValue(30) },
          description: { minLength: minLength(10) },
        },
      },
    };
  },
  components: {
    SnackNotification,
    ExperienceDialog,
    DiplomaDialog,
    ExperienceComponent,
    DiplomaComponent,
    GeneralInfoForm,
    ContactForm,
    SocialForm,
    PasswordForm,
    AddOpenningHours,
    Disponibility,
  },
  data() {
    return {
      tab: null,
      snackbar: true,
      addExperienceDialog: false,
      search: null,
      specialityItems: [
        "yoga",
        "fitness",
        "zumba",
        "boxe",
        "renforcement musculaire",
        "escrime",
        "stretching",
        "karaté",
        "football",
        "cross training",
        "cardio",
        "self défense",
        "afro dance",
        "natation",
        "boxe thailandaise",
        "boxe anglaise",
        "kick boxing",
        "dance",
        "sport de combat",
        "pilate",
        "méditation",
      ],
      experience: [
        {
          label: "",
          host: "",
          expDescription: "",
          duration: "",
        },
      ],
      image: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "user",
      loading: "loading",
    }),
    // VALIDATION ERRORS
    sessionPriceErrors() {
      const errors = [];
      if (!this.$v.user[this.user.type].sessionPrice.$dirty) return errors;
      !this.$v.user[this.user.type].sessionPrice.minValue &&
        errors.push("Le prix minimum est 10");
      !this.$v.user[this.user.type].sessionPrice.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    sessionLengthErrors() {
      const errors = [];
      if (!this.$v.user[this.user.type].sessionLength.$dirty) return errors;
      !this.$v.user[this.user.type].sessionLength.minValue &&
        errors.push("La durée minimum est 30");
      !this.$v.user[this.user.type].sessionLength.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
  },
  methods: {
    ...mapActions(["updateUser", "updateCover", "logout"]),
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("http://sprint-app.com")) return url;
      else return url + "?height=500";
    },
    onUpdateClick() {
      // if (this.$refs.generalInfo.isValide())
      this.updateUser(JSON.parse(JSON.stringify(this.user)));
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked(event) {
      this.updateCover({
        id: this.user._id,
        old: this.user.photoUrl,
        image: event.target.files[0],
      });
    },
    onLogout() {
      this.logout();
    },
  },
  // mounted: () => {
  //   this.$store.dispatch("loadUser", this.user._id);
  // }
};
</script>

<style scoped>
h2 {
  color: #121928;
}
.grad {
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
.round {
  border-radius: 10vw;
}
div p {
  margin-bottom: 0px;
}
p {
  margin-bottom: 0px;
}

.v-sheet.v-card {
  padding: 5px;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15) !important;
}
.v-label {
  font-size: 12px !important;
}
.v-input input {
  font-size: 12px !important;
}
.v-input .v-label {
  font-size: 12px !important;
}
.v-text-field input {
  font-size: 12px !important;
}
</style>
